var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',_vm._g(_vm._b({on:{"click":_vm.onClick}},'el-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }